import React, { useEffect, useState } from "react";
import RolesAndPermissionCards from "../../components/composite/RolesAndPermissionCards";
import { UserRegisterService } from "../../services/UserRegisterService";
import CircularProgress from "@mui/material/CircularProgress";
type OptionProps = {
  name: string;
  code: string;
};

type PermissionProps = {
  permissionId: (id: string[]) => void;
  selectedPermissionId: string[];
  clearPermissions?: boolean;
};
const Permissions = ({
  permissionId,
  selectedPermissionId,
  clearPermissions,
}: PermissionProps) => {
  const [selectedPermissionList, setSelectedPermissionList] = useState<
    OptionProps[]
  >([]);
  useEffect(() => {
    getAllPermissions();
  }, [clearPermissions]);
  const [permissions, setPermissions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const getAllPermissions = async () => {
    setLoading(true); // ✅ Start loading
    try {
      const response = await UserRegisterService.getPermissions();
      const allPermissions = response?.data || [];

      setPermissions(allPermissions);
      // Extract features that match selectedPermissionId
      const matchedOptions = allPermissions
        .flatMap((group: any) => group.features)
        .filter((feature: any) => selectedPermissionId.includes(feature.id));

      setSelectedPermissionList(matchedOptions);

      // Call parent callback with selected IDs
      permissionId(matchedOptions.map((item: any) => item.id));
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      setLoading(false); // ✅ Stop loading
    }
  };


  return (
    <>
      <div className="card-header managebookingg mt-4">
        <h3 className="card-title titlecolorr">Edit Permission</h3>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <CircularProgress /> {/* MUI Spinner */}
          <p>Loading permissions...</p>
        </div>
      ) : (
        <div className="row">
          {permissions?.map((i: any) => (
            <div className="col-md-4 mt-4" key={i.heading}>
              <RolesAndPermissionCards
                headerTitle={i.name}
                options={i.features}
                onSelectionChange={(updatedForCard: any) => {
                  const cardCodes = i.features.map((f: OptionProps) => f.code);
                  setSelectedPermissionList((prev) => {
                    const filteredPrev = prev.filter(
                      (item) => !cardCodes.includes(item.code)
                    );
                    const updatedSelection = [
                      ...filteredPrev,
                      ...updatedForCard,
                    ];

                    permissionId(updatedSelection.map((item: any) => item.id));
                    return updatedSelection;
                  });
                }}
                selectedOptions={selectedPermissionList.filter((item) =>
                  i.features.some((f: OptionProps) => f.code === item.code)
                )}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Permissions;
